// extracted by mini-css-extract-plugin
export default {"text":"DataListInput_text__Gv3jn","input":"DataListInput_input__pnJIY"};